import ApplyJobs from "../Pages/Miscellaneous/JobSearch/ApplyJobs";
import CardsView from "../Pages/Miscellaneous/JobSearch/CardsView";
import JobDetails from "../Pages/Miscellaneous/JobSearch/JobDetails";
import ListView from "../Pages/Miscellaneous/JobSearch/ListView";
import LearningList from "../Pages/Miscellaneous/Learning/LearningList";
import DetailedCourse from "../Pages/Miscellaneous/Learning/DetailedCourse"
import Alert from "../Pages/UiKits/Alert";
import Avatars from "../Pages/UiKits/Avatars";
import Typography from "../Pages/UiKits/Typography";
import GoogleMaps from "../Pages/Miscellaneous/Maps/GoogleMaps";
import AddPost from "../Pages/Miscellaneous/Blog/AddPost";
import BlogDetails from "../Pages/Miscellaneous/Blog/BlogDetails";
import BlogSingle from "../Pages/Miscellaneous/Blog/BlogSingle";
import Faq from "../Pages/Miscellaneous/FAQ";
import ImageHoverEffects from "../Pages/Miscellaneous/Gallery/ImageHoverEffects";
import MasonryGallery from "../Pages/Miscellaneous/Gallery/MasonryGallery";
import MasonryGalleryDescription from "../Pages/Miscellaneous/Gallery/MasonryGalleryDescription";
import Knowledgebase from "../Pages/Miscellaneous/Knowledgebase";
import GalleryDescription from "../Pages/Miscellaneous/Gallery/GalleryDescription";
import GalleryGrid from "../Pages/Miscellaneous/Gallery/GalleryGrid";
import SamplePage from "../Pages/Pages/SamplePage";
import API from "../Pages/Tables/DataTables/API";
import AdvanceInit from "../Pages/Tables/DataTables/AdvanceInit";
import BasicInit from "../Pages/Tables/DataTables/BasicInit";
import DataSource from "../Pages/Tables/DataTables/DataSource";
import TableComponents from "../Pages/Tables/ReactstrapTables/TableComponents";
import FormWizard2 from "../Pages/Forms/FormLayout/FormWizard2";
import TwoFactor from "../Pages/Forms/FormLayout/TwoFactor";
import BasicTables from "../Pages/Tables/ReactstrapTables/BasicTables";
import FormWizard1 from "../Pages/Forms/FormLayout/FormWizard1";
import Clipboard from "../Pages/Forms/FormWidgets/Clipboard";
import Typeahead from "../Pages/Forms/FormWidgets/Typeahead";
import MegaOptions from "../Pages/Forms/FormControls/MegaOptions";
import DatePicker from "../Pages/Forms/FormWidgets/Datepicker";
import Switch from "../Pages/Forms/FormWidgets/Switch";
import Touchspin from "../Pages/Forms/FormWidgets/Touchspin";
import CheckboxAndRadio from "../Pages/Forms/FormControls/CheckboxAndRadio";
import InputMask from "../Pages/Forms/FormControls/InputMask";
import GoogleChart from "../Pages/Charts/GoogleChart";
import BaseInputs from "../Pages/Forms/FormControls/BaseInputs";
import FormValidation from "../Pages/Forms/FormControls/FormValidation";
import InputGroups from "../Pages/Forms/FormControls/InputGroups";
import ApexChart from "../Pages/Charts/ApexChart";
import ChartJsChart from "../Pages/Charts/ChartJsChart";
import FeatherIcons from "../Pages/Icons/FeatherIcons";
import FontAwesome from "../Pages/Icons/FontAwesome";
import IconlyIcon from "../Pages/Icons/IconlyIcon";
import ThemifyIcon from "../Pages/Icons/ThemifyIcon";
import CreativeCard from "../Pages/BonusUi/CreativeCard";
import Timeline from "../Pages/BonusUi/Timeline";
import Buttons from "../Pages/Buttons";
import BasicCard from "../Pages/BonusUi/BasicCard";
import Breadcrumb from "../Pages/BonusUi/Breadcrumb";
import ImageCropper from "../Pages/BonusUi/ImageCropper";
import RangeSlider from "../Pages/BonusUi/RangeSlider";
import Pagination from "../Pages/BonusUi/Pagination";
import Slider from "../Pages/BonusUi/Slider";
import SweetAlert from "../Pages/BonusUi/SweetAlert";
import Dropzone from "../Pages/BonusUi/Dropzone";
import Rating from "../Pages/BonusUi/Rating";
import Ribbons from "../Pages/BonusUi/Ribbons";
import Tour from "../Pages/BonusUi/Tour";
import Scrollable from "../Pages/BonusUi/Scrollable";
import Toasts from "../Pages/BonusUi/Toasts";
import TreeView from "../Pages/BonusUi/TreeView";
import Lists from "../Pages/UiKits/Lists";
import Dropdown from "../Pages/UiKits/Dropdown";
import Modal from "../Pages/UiKits/Modal";
import Tabs from "../Pages/UiKits/TabBootstrap";
import Accordion from "../Pages/UiKits/Accordion";
import TagAndPills from "../Pages/UiKits/Tag&Pills";
import Progress from "../Pages/UiKits/Progress";
import Tooltip from "../Pages/UiKits/Tooltip";
import Grid from "../Pages/UiKits/Grid";
import HelperClasses from "../Pages/UiKits/HelperClasses";
import Popover from "../Pages/UiKits/Popover";
import Invoice6 from "../Pages/Applications/ECommerce/Invoices/Invoice6";
import Invoice5 from "../Pages/Applications/ECommerce/Invoices/Invoice5";
import Pricing from "../Pages/Applications/ECommerce/Pricing";
import Invoice1 from "../Pages/Applications/ECommerce/Invoices/Invoice1";
import Invoice2 from "../Pages/Applications/ECommerce/Invoices/Invoice2";
import Invoice3 from "../Pages/Applications/ECommerce/Invoices/Invoice3";
import Invoice4 from "../Pages/Applications/ECommerce/Invoices/Invoice4";
import CategoryPage from "../Pages/Applications/ECommerce/CategoryPage";
import ProductList from "../Pages/Applications/ECommerce/ProductList";
import PaymentDetails from "../Pages/Applications/ECommerce/PaymentDetails";
import OrderHistory from "../Pages/Applications/ECommerce/OrderHistory";
import Cart from "../Pages/Applications/ECommerce/Cart";
import Wishlist from "../Pages/Applications/ECommerce/Wishlist";
import Checkout from "../Pages/Applications/ECommerce/Checkout";
import AddProduct from "../Pages/Applications/ECommerce/AddProduct";
import Product from "../Pages/Applications/ECommerce/Product";
import ToDo from "../Pages/Applications/ToDo";
import SearchResult from "../Pages/Applications/SearchResult";
import ProductPage from "../Pages/Applications/ECommerce/ProductPage";
import Calendar from "../Pages/Applications/Calendar";
import SocialApp from "../Pages/Applications/SocialApp";
import Contacts from "../Pages/Applications/Contacts";
import Tasks from "../Pages/Applications/Tasks";
import LetterBox from "../Pages/Applications/LetterBox";
import PrivateChat from "../Pages/Applications/Chat/PrivateChat";
import GroupChat from "../Pages/Applications/Chat/GroupChat";
import EditProfile from "../Pages/Applications/Users/UsersEdit";
import ProjectCreate from "../Pages/Applications/Project/ProjectCreate";
import FileManager from "../Pages/Applications/FileManager";
import General from "../Pages/Widgets/General";
import Chart from "../Pages/Widgets/Chart";
import ProjectList from "../Pages/Applications/Project/ProjectList";
import Default from "../Pages/Dashboard/Default";
import Ecommerce from "../Pages/Dashboard/Ecommerce";
import LeafletMaps from "../Pages/Miscellaneous/Maps/LeafletMaps";
import AceCodeEditor from "../Pages/Miscellaneous/Editor/AceCodeEditor";
import QuillEditor from "../Pages/Miscellaneous/Editor/QuillEditor";
import SupportTicket from "../Pages/Miscellaneous/SupportTicket";
import UserCards from "../Pages/Applications/Users/UserCards";
import UserProfile from "../Pages/Applications/Users/UserProfile";
import Bookmarks from "../Pages/Applications/Bookmarks";
import Education from "../Pages/Dashboard/Education";
import Fleet from "../Pages/Dashboard/Fleet";


import ViewBranch from '../Pages/Branch/ViewBranch';
import AddBranch from '../Pages/Branch/AddBranch';
import EditBranch from '../Pages/Branch/EditBranch';
import ViewDriver from "../Pages/Driver/ViewDriver";
import AddDriver from "../Pages/Driver/AddDriver";
import EditDriver from "../Pages/Driver/EditDriver";
import ViewVehicle from "../Pages/Vehicle/ViewVehicle";
import AddVehicle from "../Pages/Vehicle/AddVehicle";
import EditVehicle from "../Pages/Vehicle/EditVehicle";
// import Users from "../Pages/Users";
import ViewMaintenance from "../Pages/Maintenance/ViewMaintenance";
import AddMaintenance from "../Pages/Maintenance/AddMaintenance";
import EditMaintenance from "../Pages/Maintenance/EditMaintenance";
import LPO from "../Pages/Operations/LPO";
import Reports from "../Pages/Reports";
import VehicleWiseReport from "../Pages/Reports/VehicleWise";
import BranchWiseReport from "../Pages/Reports/BranchWise";
import ExpenseReport from "../Pages/Reports/Expense";
import RenewalReport from "../Pages/Reports/Renewal";
import Users from "../Pages/Users";

import ViewInsuranceRenewal from "../Pages/InsuranceRenewal/ViewInsuranceRenewal";
import AddInsuranceRenewal from "../Pages/InsuranceRenewal/AddInsuranceRenewal";
import EditInsuranceRenewal from "../Pages/InsuranceRenewal/EditInsuranceRenewal";
import ViewRcRenewal from "../Pages/RcRenewal/ViewRcRenewal";
import AddRcRenewal from "../Pages/RcRenewal/AddRcRenewal";
import EditRcRenewal from "../Pages/RcRenewal/EditRcRenewal";
import ViewLicenseRenewal from "../Pages/LicenseRenewal/ViewLicenseRenewal";
import AddLicenseRenewal from "../Pages/LicenseRenewal/AddLicenseRenewal";
import EditLicenseRenewal from "../Pages/LicenseRenewal/EditLicenseRenewal";
import ViewAccident from "../Pages/Accidents/ViewAccident";
import AddAccident from "../Pages/Accidents/AddAccident";
import EditAccident from "../Pages/Accidents/EditAccident";
import ViewSoldVehicles from "../Pages/VehicleSale/ViewSoldVehicles";
import AddSoldVehicle from "../Pages/VehicleSale/AddSoldVehicle";
import EditSoldVehicle from "../Pages/VehicleSale/EditSoldVehicle";
import CreateLPO from "../Pages/Operations/LPO/CreateLPO";
import EditLPO from "../Pages/Operations/LPO/EditLPO";
import ViewLPO from "../Pages/Operations/LPO/ViewLPO";
import ViewFuelExpense from "../Pages/FuelExpense/ViewFuelExpense";
import AddFuelExpense from "../Pages/FuelExpense/AddFuelExpense";
import EditFuelExpense from "../Pages/FuelExpense/EditFuelExpense";
import ViewRoles from "../Pages/RoleManagement/ViewRoles";
import AddRole from "../Pages/RoleManagement/AddRole";
import EditRole from "../Pages/RoleManagement/EditRole";
import ViewEmployees from "../Pages/EmployeeManagement/ViewEmployees";
import AddEmployee from "../Pages/EmployeeManagement/AddEmployee";
import EditEmployee from "../Pages/EmployeeManagement/EditEmployee";

export const routes = [
    { path: `${process.env.PUBLIC_URL}/branch`, element: <ViewBranch /> },
    { path: `${process.env.PUBLIC_URL}/add_branch`, element: <AddBranch /> },
    { path: `${process.env.PUBLIC_URL}/edit_branch`, element: <EditBranch /> },
    { path: `${process.env.PUBLIC_URL}/driver`, element: <ViewDriver /> },
    { path: `${process.env.PUBLIC_URL}/add_driver`, element: <AddDriver /> },
    { path: `${process.env.PUBLIC_URL}/edit_driver`, element: <EditDriver /> },
    { path: `${process.env.PUBLIC_URL}/vehicle`, element: <ViewVehicle /> },
    { path: `${process.env.PUBLIC_URL}/add_vehicle`, element: <AddVehicle /> },
    { path: `${process.env.PUBLIC_URL}/edit_vehicle`, element: <EditVehicle /> },
    { path: `${process.env.PUBLIC_URL}/maintenance`, element: <ViewMaintenance /> },
    { path: `${process.env.PUBLIC_URL}/add_maintenance`, element: <AddMaintenance /> },
    { path: `${process.env.PUBLIC_URL}/edit_maintenance`, element: <EditMaintenance /> },
    { path: `${process.env.PUBLIC_URL}/insurance_renewal`, element: <ViewInsuranceRenewal /> },
    { path: `${process.env.PUBLIC_URL}/add_insurance_renewal`, element: <AddInsuranceRenewal /> },
    { path: `${process.env.PUBLIC_URL}/edit_insurance_renewal`, element: <EditInsuranceRenewal /> },
    { path: `${process.env.PUBLIC_URL}/rc_renewal`, element: <ViewRcRenewal /> },
    { path: `${process.env.PUBLIC_URL}/add_rc_renewal`, element: <AddRcRenewal /> },
    { path: `${process.env.PUBLIC_URL}/edit_rc_renewal`, element: <EditRcRenewal /> },
    { path: `${process.env.PUBLIC_URL}/license_renewal`, element: <ViewLicenseRenewal /> },
    { path: `${process.env.PUBLIC_URL}/add_license_renewal`, element: <AddLicenseRenewal /> },
    { path: `${process.env.PUBLIC_URL}/edit_license_renewal`, element: <EditLicenseRenewal /> },
    { path: `${process.env.PUBLIC_URL}/accident`, element: <ViewAccident /> },
    { path: `${process.env.PUBLIC_URL}/add_accident`, element: <AddAccident /> },
    { path: `${process.env.PUBLIC_URL}/edit_accident`, element: <EditAccident /> },
    { path: `${process.env.PUBLIC_URL}/sold_vehicle`, element: <ViewSoldVehicles /> },
    { path: `${process.env.PUBLIC_URL}/add_sold_vehicle`, element: <AddSoldVehicle /> },
    { path: `${process.env.PUBLIC_URL}/edit_sold_vehicle`, element: <EditSoldVehicle /> },
    { path: `${process.env.PUBLIC_URL}/lpo`, element: <LPO /> },
    { path: `${process.env.PUBLIC_URL}/add_lpo`, element: <CreateLPO /> },
    { path: `${process.env.PUBLIC_URL}/edit_lpo`, element: <EditLPO /> },
    { path: `${process.env.PUBLIC_URL}/view_lpo`, element: <ViewLPO /> },
    { path: `${process.env.PUBLIC_URL}/fuel_expense`, element: <ViewFuelExpense /> },
    { path: `${process.env.PUBLIC_URL}/add_fuel_expense`, element: <AddFuelExpense /> },
    { path: `${process.env.PUBLIC_URL}/edit_fuel_expense`, element: <EditFuelExpense /> },
    { path: `${process.env.PUBLIC_URL}/vehicle_report`, element: <VehicleWiseReport /> },
    { path: `${process.env.PUBLIC_URL}/branch_report`, element: <BranchWiseReport /> },
    { path: `${process.env.PUBLIC_URL}/expense_report`, element: <ExpenseReport /> },
    { path: `${process.env.PUBLIC_URL}/renewal_report`, element: <RenewalReport /> },

    { path: `${process.env.PUBLIC_URL}/reports`, element: <Reports /> },
    { path: `${process.env.PUBLIC_URL}/users`, element: <Users /> },
    { path: `${process.env.PUBLIC_URL}/role`, element: <ViewRoles /> },
    { path: `${process.env.PUBLIC_URL}/add_role`, element: <AddRole /> },
    { path: `${process.env.PUBLIC_URL}/edit_role`, element: <EditRole /> },
    { path: `${process.env.PUBLIC_URL}/employee`, element: <ViewEmployees /> },
    { path: `${process.env.PUBLIC_URL}/add_employee`, element: <AddEmployee /> },
    { path: `${process.env.PUBLIC_URL}/edit_employee`, element: <EditEmployee /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/typography`, element: <Typography /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/tabs`, element: <Tabs /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/dropdown`, element: <Dropdown /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/list`, element: <Lists /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/modal`, element: <Modal /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/helperclass`, element: <HelperClasses /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/grid`, element: <Grid /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/popover`, element: <Popover /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/avatars`, element: <Avatars /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/alert`, element: <Alert /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/add_product`, element: <AddProduct /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/product`, element: <Product /> },
    { path: `${process.env.PUBLIC_URL}/app/todo`, element: <ToDo /> },
    { path: `${process.env.PUBLIC_URL}/app/search_result`, element: <SearchResult /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/product_page`, element: <ProductPage /> },
    { path: `${process.env.PUBLIC_URL}/app/calendar`, element: <Calendar /> },
    { path: `${process.env.PUBLIC_URL}/app/social_app`, element: <SocialApp /> },
    { path: `${process.env.PUBLIC_URL}/app/contacts`, element: <Contacts /> },
    { path: `${process.env.PUBLIC_URL}/app/task`, element: <Tasks /> },
    { path: `${process.env.PUBLIC_URL}/email/letter_box`, element: <LetterBox /> },
    { path: `${process.env.PUBLIC_URL}/chat/private_chat`, element: <PrivateChat /> },
    { path: `${process.env.PUBLIC_URL}/chat/group_chat`, element: <GroupChat /> },
    { path: `${process.env.PUBLIC_URL}/users/user_edit`, element: <EditProfile /> },
    { path: `${process.env.PUBLIC_URL}/users/user_profile`, element: <UserProfile /> },
    { path: `${process.env.PUBLIC_URL}/users/cards`, element: <UserCards /> },
    { path: `${process.env.PUBLIC_URL}/project/create_new`, element: <ProjectCreate /> },
    { path: `${process.env.PUBLIC_URL}/app/file_manager`, element: <FileManager /> },
    { path: `${process.env.PUBLIC_URL}/dashboard/education`, element: <Education /> },
    { path: `${process.env.PUBLIC_URL}/widgets/general`, element: <General /> },
    { path: `${process.env.PUBLIC_URL}/widgets/chart`, element: <Chart /> },
    { path: `${process.env.PUBLIC_URL}/project/project_list`, element: <ProjectList /> },
    { path: `${process.env.PUBLIC_URL}/dashboard`, element: <Fleet /> },
    { path: `${process.env.PUBLIC_URL}/dashboard/ecommerce`, element: <Ecommerce /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/dropdown`, element: <Dropdown /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/list`, element: <Lists /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/avatars`, element: <Avatars /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/alert`, element: <Alert /> },
    { path: `${process.env.PUBLIC_URL}/job_search/card_view`, element: <CardsView /> },
    { path: `${process.env.PUBLIC_URL}/job_search/list_view`, element: <ListView /> },
    { path: `${process.env.PUBLIC_URL}/job_search/job_detail`, element: <JobDetails /> },
    { path: `${process.env.PUBLIC_URL}/job_search/apply`, element: <ApplyJobs /> },
    { path: `${process.env.PUBLIC_URL}/learning/learning_list`, element: <LearningList /> },
    { path: `${process.env.PUBLIC_URL}/learning/learning_course`, element: <DetailedCourse /> },
    { path: `${process.env.PUBLIC_URL}/map/google_map`, element: <GoogleMaps /> },
    { path: `${process.env.PUBLIC_URL}/gallery/masonry_gallery`, element: <MasonryGallery /> },
    { path: `${process.env.PUBLIC_URL}/gallery/masonry_with_desc`, element: <MasonryGalleryDescription /> },
    { path: `${process.env.PUBLIC_URL}/gallery/hover_effect`, element: <ImageHoverEffects /> },
    { path: `${process.env.PUBLIC_URL}/blog/blog_details`, element: <BlogDetails /> },
    { path: `${process.env.PUBLIC_URL}/blog/blog_single`, element: <BlogSingle /> },
    { path: `${process.env.PUBLIC_URL}/blog/add_post`, element: <AddPost /> },
    { path: `${process.env.PUBLIC_URL}/faq/faq`, element: <Faq /> },
    { path: `${process.env.PUBLIC_URL}/knowledgebase/knowledgebase`, element: <Knowledgebase /> },
    { path: `${process.env.PUBLIC_URL}/gallery/gallery_grids`, element: <GalleryGrid /> },
    { path: `${process.env.PUBLIC_URL}/gallery/gallery_grid_desc`, element: <GalleryDescription /> },
    { path: `${process.env.PUBLIC_URL}/table/reactstrap_table/table_component`, element: <TableComponents /> },
    { path: `${process.env.PUBLIC_URL}/table/data_table/basic_init`, element: <BasicInit /> },
    { path: `${process.env.PUBLIC_URL}/table/data_table/advance_init`, element: <AdvanceInit /> },
    { path: `${process.env.PUBLIC_URL}/table/data_table/api`, element: <API /> },
    { path: `${process.env.PUBLIC_URL}/table/data_table/data_sources`, element: <DataSource /> },
    { path: `${process.env.PUBLIC_URL}/pages/sample_page`, element: <SamplePage /> },
    { path: `${process.env.PUBLIC_URL}/forms/forms_layout/form_wizard_2`, element: <FormWizard2 /> },
    { path: `${process.env.PUBLIC_URL}/forms/forms_layout/two_factor`, element: <TwoFactor /> },
    { path: `${process.env.PUBLIC_URL}/table/reactstrap_table/basic_table`, element: <BasicTables /> },
    { path: `${process.env.PUBLIC_URL}/forms/forms_widget/typeahead`, element: <Typeahead /> },
    { path: `${process.env.PUBLIC_URL}/forms/forms_widget/clipboard`, element: <Clipboard /> },
    { path: `${process.env.PUBLIC_URL}/forms/forms_layout/form_wizard_1`, element: <FormWizard1 /> },
    { path: `${process.env.PUBLIC_URL}/forms/forms_controls/mega_option`, element: <MegaOptions /> },
    { path: `${process.env.PUBLIC_URL}/forms/forms_widget/datepicker`, element: <DatePicker /> },
    { path: `${process.env.PUBLIC_URL}/forms/forms_widget/touchspin`, element: <Touchspin /> },
    { path: `${process.env.PUBLIC_URL}/forms/forms_widget/switch`, element: <Switch /> },
    { path: `${process.env.PUBLIC_URL}/forms/forms_controls/radio_checkbox`, element: <CheckboxAndRadio /> },
    { path: `${process.env.PUBLIC_URL}/forms/forms_controls/input_mask`, element: <InputMask /> },
    { path: `${process.env.PUBLIC_URL}/charts/google_chart`, element: <GoogleChart /> },
    { path: `${process.env.PUBLIC_URL}/forms/forms_controls/base_input`, element: <BaseInputs /> },
    { path: `${process.env.PUBLIC_URL}/forms/forms_controls/form_validation`, element: <FormValidation /> },
    { path: `${process.env.PUBLIC_URL}/forms/forms_controls/input_groups`, element: <InputGroups /> },
    { path: `${process.env.PUBLIC_URL}/icons/fontawesome_icon`, element: <FontAwesome /> },
    { path: `${process.env.PUBLIC_URL}/icons/feather_icon`, element: <FeatherIcons /> },
    { path: `${process.env.PUBLIC_URL}/icons/iconly_icon`, element: <IconlyIcon /> },
    { path: `${process.env.PUBLIC_URL}/icons/themify_icon`, element: <ThemifyIcon /> },
    { path: `${process.env.PUBLIC_URL}/charts/apex_chart`, element: <ApexChart /> },
    { path: `${process.env.PUBLIC_URL}/charts/chartjs_chart`, element: <ChartJsChart /> },
    { path: `${process.env.PUBLIC_URL}/bonus_ui/creative_cards`, element: <CreativeCard /> },
    { path: `${process.env.PUBLIC_URL}/bonus_ui/timeline`, element: <Timeline /> },
    { path: `${process.env.PUBLIC_URL}/buttons`, element: <Buttons /> },
    { path: `${process.env.PUBLIC_URL}/bonus_ui/breadcrumb`, element: <Breadcrumb /> },
    { path: `${process.env.PUBLIC_URL}/bonus_ui/range_slider`, element: <RangeSlider /> },
    { path: `${process.env.PUBLIC_URL}/bonus_ui/image_cropper`, element: <ImageCropper /> },
    { path: `${process.env.PUBLIC_URL}/bonus_ui/basic_cards`, element: <BasicCard /> },
    { path: `${process.env.PUBLIC_URL}/bonus_ui/sweet_alert2`, element: <SweetAlert /> },
    { path: `${process.env.PUBLIC_URL}/bonus_ui/slider`, element: <Slider /> },
    { path: `${process.env.PUBLIC_URL}/bonus_ui/pagination`, element: <Pagination /> },
    { path: `${process.env.PUBLIC_URL}/bonus_ui/rating`, element: <Rating /> },
    { path: `${process.env.PUBLIC_URL}/bonus_ui/dropzone`, element: <Dropzone /> },
    { path: `${process.env.PUBLIC_URL}/bonus_ui/tour`, element: <Tour /> },
    { path: `${process.env.PUBLIC_URL}/bonus_ui/ribbons`, element: <Ribbons /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/list`, element: <Lists /> },
    { path: `${process.env.PUBLIC_URL}/bonus_ui/scrollable`, element: <Scrollable /> },
    { path: `${process.env.PUBLIC_URL}/bonus_ui/tree_view`, element: <TreeView /> },
    { path: `${process.env.PUBLIC_URL}/bonus_ui/toasts`, element: <Toasts /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/tabs`, element: <Tabs /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/dropdown`, element: <Dropdown /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/modal`, element: <Modal /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/helperclass`, element: <HelperClasses /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/grid`, element: <Grid /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/popover`, element: <Popover /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/accordion`, element: <Accordion /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/tagpills`, element: <TagAndPills /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/progress`, element: <Progress /> },
    { path: `${process.env.PUBLIC_URL}/ui_kits/tooltip`, element: <Tooltip /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice5`, element: <Invoice5 /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice6`, element: <Invoice6 /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/pricing`, element: <Pricing /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice1`, element: <Invoice1 /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice2`, element: <Invoice2 /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice3`, element: <Invoice3 /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice4`, element: <Invoice4 /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/category_page`, element: <CategoryPage /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/product_list`, element: <ProductList /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/payment_details`, element: <PaymentDetails /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/order_history`, element: <OrderHistory /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/cart`, element: <Cart /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/wishlist`, element: <Wishlist /> },
    { path: `${process.env.PUBLIC_URL}/ecommerce/checkout`, element: <Checkout /> },
    { path: `${process.env.PUBLIC_URL}/map/leaflet_map`, element: <LeafletMaps /> },
    { path: `${process.env.PUBLIC_URL}/editor/quill_editor`, element: <QuillEditor /> },
    { path: `${process.env.PUBLIC_URL}/editor/ace_editor`, element: <AceCodeEditor /> },
    { path: `${process.env.PUBLIC_URL}/support_ticket/support_ticket`, element: <SupportTicket /> },
    { path: `${process.env.PUBLIC_URL}/app/bookmark`, element: <Bookmarks /> },

]